import { Suspense } from "react";
import { AppLayout, AppSidebar, MainContent } from "../Layout";
import { Link } from "react-router-dom";

const ResourceMenu = () => {
  const resourceLinks = [
    {
      description: "Antibiotic prescribing in primary care - summary table",
      summary: true,
      link: "https://ccmsfiles.tg.org.au/s7/PDFs/Antibiotic-Summary-table.pdf",
    },
    {
      description: "Surgical prophylaxis - summary tables",
      summary: true,
      link: "https://ccmsfiles.tg.org.au/s7/PDFs/ABG16-Surgical-antibiotic-prophylaxis-Collated-table-v4.pdf?type=Surgical%20prophylaxis%20-%20summary%20tables",
    },
    {
      description: "Patient information and useful PDFs",
      link: "/patientInfo",
    },
    {
      description: "Pregnancy and breastfeeding",
      link: "/guidelines/Pregnancy_and_Breastfeeding",
    },
    {
      description: "Tables and figures",
      link: "/tables-and-figures",
    },
  ]

  return (
    <>
      <Suspense fallback={<div className="loader"></div>}>
        <AppLayout
          useMainContentWrapper={false}
          appSidebar={<AppSidebar />}
        >
          <MainContent
            padding="default"
          >
            {resourceLinks.map((resource) => (
              <div>
                <Link
                  key={resource.description}
                  to={resource.link}
                >{resource.description}</Link>
              </div>
            ))}
          </MainContent>
        </AppLayout>
      </Suspense>
    </>
  );
};

export default ResourceMenu;
